export default __webpack_public_path__ + "static/media/logo-pinjam-modal.fa7e1bc4.svg";